import React from 'react';

import {
  Box,
  Flex, // eslint-disable-next-line no-restricted-imports -- no-restricted-syntax
  Link,
  Text,
} from '@opendoor/bricks/core';

import { HOMEPAGE_URL } from 'shared/helpers/globals';
import { useMobileDevice } from 'shared/helpers/hooks/useMobileDevice';

import { CustomerCareContactCard } from 'buying/components/buyDirectCheckout/CustomerCareContactCard';
import { CheckoutState } from 'buying/stateMachines/buyDirectCheckoutFlowStateMachine';

interface IConfirmationProps {
  addressId: string | null;
  previousState?: CheckoutState;
}

/**
 * Confirmation step state machine implementation
 * storybook-check-ignore
 */
export const Confirmation: React.FC<IConfirmationProps> = React.memo(
  ({ addressId, previousState }) => {
    const { isMobile } = useMobileDevice();
    return (
      <Flex flexDirection="column" alignItems={isMobile ? 'center' : undefined} width="100%">
        <Text
          size={isMobile ? '160' : '150'}
          fontWeight="medium"
          alignSelf="flex-start"
          ml={[8, null, -2]}
        >
          {previousState !== CheckoutState.CreateBuyDirectListingOfferDeadline
            ? 'Have questions?'
            : 'Want to contact us right now?'}
        </Text>
        <Box my={8} width={['85%', null, '100%']}>
          <CustomerCareContactCard />
        </Box>
        <Link
          alignSelf={['center', null, 'flex-end']}
          analyticsName="buy-direct-checkout-back-to-listing"
          aria-label="Back to listing"
          size="md"
          mt={8}
          data-testid="buy-direct-checkout-back-to-listing-button"
          width={['90%', null, '25%']}
          href={`${HOMEPAGE_URL}/properties/aid_${addressId}`}
          variant="primary-button"
        >
          <Text size="110" fontWeight="medium" color="white0">
            Back to listing
          </Text>
        </Link>
      </Flex>
    );
  },
);

Confirmation.displayName = 'Confirmation';
